import React from 'react';

let characterInterval:any;

interface IProps {
  characterCount?:any;
  onElfClick?:any;
  giveaway?:any;
  site?:any;
}

interface IState {
  height?:any;
  width?:any;
  snowClass?:any;
  activeClass?:any;
  character?:any;
}

class HolidayElves extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
      super(props);
      this.state={};
  }
  componentDidMount = () =>{
    this.startGame();
  }
  componentWillUnMount = () =>{
    clearInterval(characterInterval);
  }
  startGame = () => {
    characterInterval = setInterval(()=>this.positionCharacter(), 10000);
  }
  onClick = () =>{
    if(this.props.giveaway){
      this.props.onElfClick()
    }
  }
  positionCharacter = () =>{

    let numberOfCharacters = this.props.characterCount ? this.props.characterCount : "1";
    if(numberOfCharacters){
      numberOfCharacters = parseFloat(numberOfCharacters)
    }

    var randomNumber = Math.floor(Math.random()*2) + 1;
    var randomNumber = 1;
    if(randomNumber == 1){
      var characterBox = 275;
      if(window.outerWidth < 800){
        characterBox = 170;
      }
      var randomClassChooser = Math.floor(Math.random()*6) + 1;
      var snowClass="position-"+randomClassChooser;
      var randomCharacter = Math.floor(Math.random() * numberOfCharacters) + 1;
      var site = this.props.site;
      let imageUrl = 'https://assets.hosports.com/holiday/'+site+'-holiday-character-'+randomCharacter+'.png';

      this.setState({
        height:characterBox,
        width:characterBox,
        snowClass:snowClass,
        activeClass:"",
        character:imageUrl
      },()=>{
        setTimeout(()=>{
          this.setState({
            activeClass:"active"
          },()=>{
            setTimeout(()=>{
              this.setState({
                activeClass:""
              })
            },1500);
          })
        },1000);
      })
    }
  }
  public render(): JSX.Element {
    if(!this.state.character) return <span/>;
    console.log(this.state.activeClass)
    return(
      <div
        onClick={this.onClick}
        id="holiday-character"
        className={this.state.snowClass+" "+this.state.activeClass}
        style={{
          height:this.state.height,
          width:this.state.width
        }}>
        <div className="wiggler full-width">
          <img
            src={this.state.character}
            className="full-width"
          />
        </div>
      </div>
    )
  }
}

//@ts-ignore
export default HolidayElves;
